import React from 'react';
import Data from './Data';

const SolarSearchSidebar = (props) => {
  return <Data {...props} />;
};

export default SolarSearchSidebar;
